// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_PsShl {
  flex: 1 1;
  width: 100%;
}

.statsContainer_sX6Ge {
  display: flex;
  height: 80px;
  align-items: center;
  justify-content: flex-start;
  overflow-x: scroll;
  overflow-y: hidden;
  padding-left: 20px;

  &::-webkit-scrollbar {
    display: none;
  }
}

.statsContainerImport_qyTOQ {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  overflow-x: scroll;
  overflow-y: hidden;
  flex-direction: column;

  .statsContainerImportList_ByOHF {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    flex-direction: column;
    gap: 10px;
    list-style: none;
    width: 100%;
    padding: 0px;

    li {
      border-radius: 8px;
      padding: 2px 10px 4px;
      background: #eaeaea;
      text-transform: uppercase;
      font-weight: 500;
      font-size: 12px;

      div {
        display: flex;
        align-items: center;
        gap: 10px;
        font-size: 14px;
        font-weight: 500;

        b {
          font-size: 30px;
          color: #000;
        }

        span {
          font-size: 16px;
          position: relative;
          top: 4px;
          left: -4px;
        }
      }
    }
  }
}

.infoProfilesContainer_mBCTh {
  display: flex;
  align-items: center;
  gap: 5px;
}

.initials_L8C0Q,
.profileImage_Yr8de {
  width: 34px;
  height: 34px;
  min-width: 34px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--_16c098-background);
  color: var(--white-color);
  font-size: 16px;
  font-weight: 600;
}

.profileImage_Yr8de {
  object-fit: cover;
}



.statCard_YHtBc {
  padding: 6px 10px;
  position: relative;
  display: flex;
  align-items: flex-start;
  border-right: 1px solid var(--_e6-color);
  margin-right: 24px;
  gap: 4px;



  &:last-child {
    margin-right: 0px;
  }
}

.statCard_YHtBc:first-child {
  padding-left: 0px;
}

.statCard_YHtBc:last-child {
  border-right: 1px solid transparent;
}

.statContent_HgDd1 {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: flex-start;
  min-width: 120px;
  max-width: 160px;
}

.statTitle_szfQ5 {
  font-size: 14px;
  color: var(--b5b7c0-color);
  font-weight: 500;
  margin-bottom: 4px;
}

.statValue_nehsA {
  left: -14px;
  bottom: -20px;
  font-size: 18px;
  font-weight: 600;
  color: var(--_292d32-color);
  position: absolute;
  width: 30px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--white-background);
  border-radius: 60px;
}

.statChange_aY8nJ {
  font-size: 12px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 4px;
}

.statChange_aY8nJ svg {
  font-size: 20px;
  margin-bottom: 3px;
  margin-right: 3px;
}

.positive_J0g2_ {
  color: var(--_233f39-color);
}

.negative_y2BBw {
  color: var(--d0004b-color);
}

.avatars_RccrB {
  display: flex;
  flex-direction: row;
  margin-left: 8px;
}

.avatars_RccrB img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-size: cover;
  margin-left: -8px;
  border: 2px solid var(--white-border);
}

.tableSection_p2Dse {
  background: var(--white-background);
  padding: 24px 10px;
  width: 98%;
  overflow-y: auto;
  display: grid;
  flex-direction: column;
  gap: 10px;
  border-radius: 20px 0px 0px 0px;
}

.changeTabButton_veGf2 {
  display: flex;
  font-size: 12px;
  font-weight: 400;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  align-items: center;
  justify-content: center;
  width: max-content;
  background: linear-gradient(90deg, var(--_11a380-background) 0%, var(--_0c6d56-background) 100%);
  color: var(--white-color);
  outline: none;
  height: 20px;
  border: none;
  border-radius: 7px;
  min-width: 90px;
  -webkit-border-radius: 7px;
  -moz-border-radius: 7px;
  -ms-border-radius: 7px;
  -o-border-radius: 7px;
}

.tableTitle_sXPia {
  font-size: 22px;
  font-weight: 600;
  line-height: 20px;
  color: var(--black-color);
  margin-top: -9px;
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: flex-start;
}

.filters_yDDnY {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.filterSearch_XpCR5 {
  flex: 1 1;
  display: flex;
  align-items: center;
  border: 1px solid var(--d8-border);
  gap: 8px;
  width: 300px;
  overflow: hidden;
  border-radius: 10px;
  height: 40px;
  padding-left: 12px;
}

.filterSearch_XpCR5 input {
  border: none;
  outline: none;
  background: none;
  font-size: 12px;
  font-weight: 400;
  color: var(--b5b7c0-color);
  flex: 1 1;
}

.filterSort_zIqnm {
  font-size: 14px;
  font-weight: 500;
  color: var(--_292d32-color);
}



.tableHeader_fvqLu,
.tableRow_SChJd {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  font-size: 14px;
}

.tableHeader_fvqLu {
  background: var(--fa-background);
  border-radius: 3px;
  color: var(--_48-color);
  font-weight: 500;
  font-size: 14px;
}

.tableRow_SChJd {
  color: var(--_292d32-color);
  border-bottom: 1px solid var(--e-border);
}

.tableRow_SChJd:last-child {
  border-bottom: none;
}

.columnName_C8lYx {
  flex: 0.3 1;
}


.columnContact_nFWHe {
  flex: 0.1 1;
}


.gapDiv_cFGfI {
  display: flex;
  flex-direction: row;
  gap: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: calc(100vw * 0.17);
}

.columnEmail_rDPI7 {
  flex: 0.15 1;
}

.columnRecognitions_Ji1XE {
  flex: 0.15 1;
  text-align: center;
}

.columnMonth_Rnvew {
  flex: 0.20 1;
  color: var(--_16c098-color);
  text-align: center;
}






.icon_SbYxE {
  width: 16px;
  height: 16px;
}

.switch_FRiWE {
  position: relative;
  display: inline-block;
  width: 34px;
  height: 20px;
}

.switch_FRiWE input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider_V2WrS {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--c-background);
  border-radius: 34px;
  cursor: pointer;
  transition: 0.4s;
}

.slider_V2WrS:before {
  position: absolute;
  content: "";
  height: 14px;
  width: 14px;
  left: 3px;
  bottom: 3px;
  background-color: var(--white-background);
  border-radius: 50%;
  transition: 0.4s;
}

input:checked+.slider_V2WrS {
  background-color: var(--_16c098-background);
}

input:checked+.slider_V2WrS:before {
  transform: translateX(14px);
}

.pagination_MSnhR {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  font-size: 14px;
  color: var(--b5b7c0-color);
}

.paginationControls_SLEwv {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pageNumber__Vzk9 {
  padding: 4px 8px;
  cursor: pointer;
  border-radius: 4px;
  color: var(--_292d32-color);
}

.iconWrapper_tgfER {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 55px;
  height: 55px;
  min-width: 55px;
  min-height: 55px;
  border-radius: 50%;
  background: linear-gradient(to right, var(--d8ffea-background) 0%, var(--effff6-background) 37%, var(--effff6-background) 100%);
}

.pageNumber__Vzk9:hover {
  background-color: var(--f8f9fa-background);
}

.chevron_rNpyo {
  color: var(--b5b7c0-color);
  cursor: pointer;
}

.tableTopContainer_k6PtO {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
}

.tableHeaderContainer_ZV2eV {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}

.addClientButton_hakxl {
  display: flex;
  flex-direction: row;
  gap: 10px;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  align-items: center;
  justify-content: flex-start;
  background: linear-gradient(90deg, var(--_11a380-background) 0%, var(--_0c6d56-background) 100%);
  color: var(--white-color);
  outline: none;
  padding: 0px 10px;
  height: 42px;
  border: none;
  border-radius: 7px;
  -webkit-border-radius: 7px;
  -moz-border-radius: 7px;
  -ms-border-radius: 7px;
  -o-border-radius: 7px;
}

.tableSpan_Qq0Fc {
  color: var(--_16c098-color);
  font-size: 14px;
  font-weight: 400;
}



.dropdownContainer_n6vV5 {
  position: relative;
  display: inline-block;
}

.filterSort_zIqnm {
  font-size: 12px;
  font-weight: 400;
  color: var(--_7e-color);
  height: 40px;
  border: 1px solid var(--d8-border);
  border-radius: 10px;
  padding: 0px 12px;
  width: 240px;
  max-width: 240px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
}

.filterSort_zIqnm b {
  font-weight: 600;
  color: var(--_3d3c42-color);
  margin-left: 6px;
}

.chevronIcon_P_J98 {
  margin-left: auto;
  color: var(--_292d32-color);
}

.dropdownOptions_kX65y {
  position: absolute;
  top: calc(100% - 2px);
  left: 0;
  width: 100%;
  margin-top: 4px;
  background: var(--white-background);
  border-radius: 10px;
  box-shadow: 0px 4px 8px var(--_0000001a-shadow);
  z-index: 1000;
  overflow: hidden;
}

.dropdownOption_LB2Yk {
  padding: 8px 12px;
  font-size: 12px;
  font-weight: 500;
  color: var(--_9c9d9f-color);
  cursor: pointer;
  transition: background-color 0.2s;
}

.dropdownOption_LB2Yk:hover {
  background-color: var(--f0f2f8-background);
}




.greenButton_uhelQ {
  width: 100px;
  background: linear-gradient(90deg, var(--_11a380-background) 0%, var(--_0c6d56-background) 100%);

  color: var(--white-color);
  font-size: 11px;
  height: 30px;
  font-weight: 400;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-user-select: none;
          user-select: none;
  gap: 5px;
}

.homeContainer_bn3Hg {
  width: 100%;
  /* background-color: var(--white-background); */
  /* border-radius: 20px 0px 0px 0px; */
  min-height: 100vh;
  overflow-y: scroll;
}

.statisticsHeader_RD3Ci {
  display: flex;
  width: 100%;
  padding: 0px 10px;
  box-sizing: border-box;
  gap: 20px;

  >div {
    width: 100%;
  }

  .staticsContainer_MFDb5 {
    display: flex;
    flex-wrap: wrap;
  }

  p {
    margin: 0;
  }

  .statisticCard_IBsfn {
    flex: 1 1;
    padding: 20px;
    box-sizing: border-box;
  }

  .title_EWm1x {
    display: flex;
    justify-content: space-between;

    p {
      font-size: 20px;
      font-weight: bold;
      text-transform: capitalize;
    }

    .icon_SbYxE {
      cursor: pointer;
      transform: rotate(90deg);
      -webkit-transform: rotate(90deg);
      -moz-transform: rotate(90deg);
      -ms-transform: rotate(90deg);
      -o-transform: rotate(90deg);
    }
  }

  span {
    color: var(--a6-color);
    font-weight: bold;
    text-transform: uppercase;
  }

  .statisticTotal_vh3Sr {
    font-size: 30px;
    text-align: end;
    font-weight: bold;
  }
}

@media screen and (max-width: 1024px) {

  .statisticsHeader_RD3Ci,
  .homeContent_GUAgA {
    flex-direction: column;
  }
}

.divider_nF46r {
  width: 100%;
  height: 8px;
  background-color: var(--f3-background);
  border-radius: 99px;
  -webkit-border-radius: 99px;
  -moz-border-radius: 99px;
  -ms-border-radius: 99px;
  -o-border-radius: 99px;
}

.analitycsHeader_P75bM {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  padding: 10px;

  .data_FVSUh {
    display: flex;
    align-items: center;
    margin-left: 10px;
    gap: 10px;

    svg {
      width: 30px;
      height: 30px;
    }
  }
}

.analitycsHeaderRight_pntob {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;

  @media (width <=768px) {
    padding: 0 10px;
  }
}

.timerContainer__JLBg {
  display: flex;
  align-items: center;
  flex: 1 1;
  gap: 10px;
}

.talkWithFacturaGPT_no3cg {
  display: flex;
  height: 38px;
  min-width: 225px;
  padding: 0px 12px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex: 1 1;
  border-radius: 8px;
  background: var(--_10a37f-background);
  box-shadow:
    0px 0px 2px 0px var(--_00000008-shadow),
    0px 0px 0px 0px var(--_00000000-shadow),
    0px 0px 0px 0px var(--_00000000-shadow);
  color: var(--white-color);
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  cursor: pointer;
}

.homeContent_GUAgA {
  display: flex;
  padding: 20px;
  flex-wrap: wrap;
  gap: 20px;
}

.salesSummaryContainer_DW9a_ {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 50px;
  box-sizing: border-box;
}

.salesSummary_VkaAl {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.salesSummaryHeader_AKY40 {
  display: flex;
  flex-direction: column;
  gap: 10px;

  p {
    font-weight: bold;
    font-size: 20px;
    margin: 0;
  }

  span {
    color: var(--a6-color);
    font-weight: bold;
    font-size: 20px;
    text-transform: uppercase;
  }
}



.salesSummaryOptions_ssmyT {
  display: flex;
  gap: 10px;
  align-items: center;

  span {
    text-transform: initial;
    font-size: 16px;
    color: var(--_00000035-color);
  }
}

.monthsContainer_s6jdY {
  display: flex;
  gap: 10px;

  p::before {
    content: "";
    height: var(--percent, 2px);
    min-height: 2px;
    width: 100%;
    background-color: var(--_2b0e50-background);
    display: block;
    position: absolute;
    top: 0px;
  }

  p {
    margin: 0;
    padding-top: 10px;
    position: relative;
    flex: 1 1;
  }
}

.expenseAccounts_EDuFf {
  flex: 1 1;
}

.expenseAccounts_EDuFf {
  display: flex;
  flex-direction: column;
  gap: 10px;

  p {
    margin: 0;
  }

  .spent_Kz9jE {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 10px;

    .row__sQtm {
      display: flex;
      align-items: center;
      justify-content: space-between;

      p {
        color: var(--black-color);
        font-weight: bold;
      }
    }

    span {
      color: var(--_22024b-color);
      min-width: 150px;
    }
  }
}

.expenseAccountsOptions_bsd00 {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 10px 0;

  span {
    text-transform: initial;
    font-size: 16px;
    color: var(--_00000035-color);
    font-weight: bold;
    cursor: pointer;
  }

  .selectedTypeExpense_doWdz {
    font-weight: bold;
    font-size: 20px;
    margin: 0;
    color: var(--black-color);
  }
}

.expenseAccountsHeader_gB60I {
  display: flex;
  gap: 10px;

  button {
    flex: 1 1;
    background-color: transparent;
    border: none;
    outline: none;
    color: var(--_b4-color);
    font-family: Inter;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    cursor: pointer;
    border: 1px solid transparent;
    padding: 1px;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
  }

  .selectedTabBtn_gHAJA {
    color: var(--_0d-color);
    border: 1px solid var(--_0000001a-border);
    box-shadow:
      0px 0px 2px 0px var(--_00000008-shadow),
      0px 0px 0px 0px var(--_00000000-shadow),
      0px 0px 0px 0px var(--_00000000-shadow);
  }
}

.buttonContainerTableTop_yMlrM {
  display: flex;
  align-items: center;
  gap: 10px;

}

.buttonContainerTableTop1_soK5f {
  display: flex;
  align-items: center;
  gap: 10px;
  label {
     margin: 0px;
  }
  button {
    background-color: transparent;
    border: none;
    outline: none;
    cursor: pointer;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    background-color: var(--white-background);
    border: 1px solid var(--_0000001a-border);
  }
}

.filtersTableTop_td1vG {
  display: flex;
  flex-direction: column;
  align-items: end;
  gap: 16px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.searchIconsWrappers_P_OdA {
  display: flex;
  align-items: center;
  gap: 5px;
}

.modalOverlay_LRD9I {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modalContent_Id1Xr {
  background: var(--white-background);
  padding: 24px;
  border-radius: 12px;
  max-width: 500px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
}

.modalContent_Id1Xr h2 {
  margin: 0 0 16px 0;
  color: var(--black-color);
  font-size: 20px;
  font-weight: 600;
}

.modalContent_Id1Xr p {
  margin: 8px 0;
  color: var(--b5b7c0-color);
  font-size: 14px;
}

.modalContent_Id1Xr ul {
  margin: 12px 0;
  padding-left: 20px;
}

.modalContent_Id1Xr li {
  margin: 4px 0;
  color: var(--b5b7c0-color);
  font-size: 14px;
}

.modalButtons_i3LJM {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 24px;
}

.paymentMethodInfo_lAOHv{
  display: flex;
  align-items: center;
  object-fit: contain;
  gap: 5px;
  img{
    height: 10px;
    width: 20px;
  }
  .cardInfo_ktTLf{
    display: flex;
    flex-direction: column;
  }
}

.succeeded_qJwL3{
  color: rgb(0, 159, 122);
}
.failed_K3A16{
  color: rgb(197, 34, 31);
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/Dashboard.module.css"],"names":[],"mappings":"AAAA;EACE,SAAO;EACP,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;;EAElB;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;;EAEtB;IACE,aAAa;IACb,kCAAkC;IAClC,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,WAAW;IACX,YAAY;;IAEZ;MACE,kBAAkB;MAClB,qBAAqB;MACrB,mBAAmB;MACnB,yBAAyB;MACzB,gBAAgB;MAChB,eAAe;;MAEf;QACE,aAAa;QACb,mBAAmB;QACnB,SAAS;QACT,eAAe;QACf,gBAAgB;;QAEhB;UACE,eAAe;UACf,WAAW;QACb;;QAEA;UACE,eAAe;UACf,kBAAkB;UAClB,QAAQ;UACR,UAAU;QACZ;MACF;IACF;EACF;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;;;AAIA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,wCAAwC;EACxC,kBAAkB;EAClB,QAAQ;;;;EAIR;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gGAAgG;EAChG,yBAAyB;EACzB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;;;AAIA;;EAEE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAS;AACX;;;AAGA;EACE,WAAS;AACX;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,YAAU;AACZ;;AAEA;EACE,YAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,YAAU;EACV,2BAA2B;EAC3B,kBAAkB;AACpB;;;;;;;AAOA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,+HAA+H;AACjI;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,gGAAgG;EAChG,yBAAyB;EACzB,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;;;;AAIA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,WAAW;EACX,eAAe;EACf,mCAAmC;EACnC,mBAAmB;EACnB,+CAA+C;EAC/C,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,0CAA0C;AAC5C;;;;;AAKA;EACE,YAAY;EACZ,gGAAgG;;EAEhG,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAiB;UAAjB,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,+CAA+C;EAC/C,qCAAqC;EACrC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,SAAS;;EAET;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAO;IACP,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,8BAA8B;;IAE9B;MACE,eAAe;MACf,iBAAiB;MACjB,0BAA0B;IAC5B;;IAEA;MACE,eAAe;MACf,wBAAwB;MACxB,gCAAgC;MAChC,6BAA6B;MAC7B,4BAA4B;MAC5B,2BAA2B;IAC7B;EACF;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;;EAEE;;IAEE,sBAAsB;EACxB;AACF;;AAEA;EACE,WAAW;EACX,WAAW;EACX,sCAAsC;EACtC,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,aAAa;;EAEb;IACE,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,SAAS;;IAET;MACE,WAAW;MACX,YAAY;IACd;EACF;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;;EAEf;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAO;EACP,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,SAAO;EACP,kBAAkB;EAClB,qCAAqC;EACrC;;;2CAGyC;EACzC,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;;EAET;IACE,iBAAiB;IACjB,eAAe;IACf,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,eAAe;IACf,yBAAyB;EAC3B;AACF;;;;AAIA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;;EAEnB;IACE,uBAAuB;IACvB,eAAe;IACf,6BAA6B;EAC/B;AACF;;AAEA;EACE,aAAa;EACb,SAAS;;EAET;IACE,WAAW;IACX,2BAA2B;IAC3B,eAAe;IACf,WAAW;IACX,2CAA2C;IAC3C,cAAc;IACd,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,SAAS;IACT,iBAAiB;IACjB,kBAAkB;IAClB,SAAO;EACT;AACF;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;;EAET;IACE,SAAS;EACX;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;;IAEnB;MACE,aAAa;MACb,mBAAmB;MACnB,8BAA8B;;MAE9B;QACE,yBAAyB;QACzB,iBAAiB;MACnB;IACF;;IAEA;MACE,2BAA2B;MAC3B,gBAAgB;IAClB;EACF;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;;EAEd;IACE,uBAAuB;IACvB,eAAe;IACf,6BAA6B;IAC7B,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,SAAS;IACT,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,SAAS;;EAET;IACE,SAAO;IACP,6BAA6B;IAC7B,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,uBAAuB;IACvB,yCAAyC;IACzC;;;6CAGyC;EAC3C;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;;AAEX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT;KACG,WAAW;EACd;EACA;IACE,6BAA6B;IAC7B,YAAY;IACZ,aAAa;IACb,eAAe;IACf,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,yCAAyC;IACzC,yCAAyC;EAC3C;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;AACF;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB","sourcesContent":[".container {\n  flex: 1;\n  width: 100%;\n}\n\n.statsContainer {\n  display: flex;\n  height: 80px;\n  align-items: center;\n  justify-content: flex-start;\n  overflow-x: scroll;\n  overflow-y: hidden;\n  padding-left: 20px;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n.statsContainerImport {\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  overflow-x: scroll;\n  overflow-y: hidden;\n  flex-direction: column;\n\n  .statsContainerImportList {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    flex-direction: column;\n    gap: 10px;\n    list-style: none;\n    width: 100%;\n    padding: 0px;\n\n    li {\n      border-radius: 8px;\n      padding: 2px 10px 4px;\n      background: #eaeaea;\n      text-transform: uppercase;\n      font-weight: 500;\n      font-size: 12px;\n\n      div {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        font-size: 14px;\n        font-weight: 500;\n\n        b {\n          font-size: 30px;\n          color: #000;\n        }\n\n        span {\n          font-size: 16px;\n          position: relative;\n          top: 4px;\n          left: -4px;\n        }\n      }\n    }\n  }\n}\n\n.infoProfilesContainer {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.initials,\n.profileImage {\n  width: 34px;\n  height: 34px;\n  min-width: 34px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--_16c098-background);\n  color: var(--white-color);\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.profileImage {\n  object-fit: cover;\n}\n\n\n\n.statCard {\n  padding: 6px 10px;\n  position: relative;\n  display: flex;\n  align-items: flex-start;\n  border-right: 1px solid var(--_e6-color);\n  margin-right: 24px;\n  gap: 4px;\n\n\n\n  &:last-child {\n    margin-right: 0px;\n  }\n}\n\n.statCard:first-child {\n  padding-left: 0px;\n}\n\n.statCard:last-child {\n  border-right: 1px solid transparent;\n}\n\n.statContent {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  justify-content: flex-start;\n  min-width: 120px;\n  max-width: 160px;\n}\n\n.statTitle {\n  font-size: 14px;\n  color: var(--b5b7c0-color);\n  font-weight: 500;\n  margin-bottom: 4px;\n}\n\n.statValue {\n  left: -14px;\n  bottom: -20px;\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--_292d32-color);\n  position: absolute;\n  width: 30px;\n  height: 30px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--white-background);\n  border-radius: 60px;\n}\n\n.statChange {\n  font-size: 12px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.statChange svg {\n  font-size: 20px;\n  margin-bottom: 3px;\n  margin-right: 3px;\n}\n\n.positive {\n  color: var(--_233f39-color);\n}\n\n.negative {\n  color: var(--d0004b-color);\n}\n\n.avatars {\n  display: flex;\n  flex-direction: row;\n  margin-left: 8px;\n}\n\n.avatars img {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background-size: cover;\n  margin-left: -8px;\n  border: 2px solid var(--white-border);\n}\n\n.tableSection {\n  background: var(--white-background);\n  padding: 24px 10px;\n  width: 98%;\n  overflow-y: auto;\n  display: grid;\n  flex-direction: column;\n  gap: 10px;\n  border-radius: 20px 0px 0px 0px;\n}\n\n.changeTabButton {\n  display: flex;\n  font-size: 12px;\n  font-weight: 400;\n  cursor: pointer;\n  user-select: none;\n  align-items: center;\n  justify-content: center;\n  width: max-content;\n  background: linear-gradient(90deg, var(--_11a380-background) 0%, var(--_0c6d56-background) 100%);\n  color: var(--white-color);\n  outline: none;\n  height: 20px;\n  border: none;\n  border-radius: 7px;\n  min-width: 90px;\n  -webkit-border-radius: 7px;\n  -moz-border-radius: 7px;\n  -ms-border-radius: 7px;\n  -o-border-radius: 7px;\n}\n\n.tableTitle {\n  font-size: 22px;\n  font-weight: 600;\n  line-height: 20px;\n  color: var(--black-color);\n  margin-top: -9px;\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.filters {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.filterSearch {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  border: 1px solid var(--d8-border);\n  gap: 8px;\n  width: 300px;\n  overflow: hidden;\n  border-radius: 10px;\n  height: 40px;\n  padding-left: 12px;\n}\n\n.filterSearch input {\n  border: none;\n  outline: none;\n  background: none;\n  font-size: 12px;\n  font-weight: 400;\n  color: var(--b5b7c0-color);\n  flex: 1;\n}\n\n.filterSort {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--_292d32-color);\n}\n\n\n\n.tableHeader,\n.tableRow {\n  display: flex;\n  align-items: center;\n  padding: 12px 16px;\n  font-size: 14px;\n}\n\n.tableHeader {\n  background: var(--fa-background);\n  border-radius: 3px;\n  color: var(--_48-color);\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.tableRow {\n  color: var(--_292d32-color);\n  border-bottom: 1px solid var(--e-border);\n}\n\n.tableRow:last-child {\n  border-bottom: none;\n}\n\n.columnName {\n  flex: 0.3;\n}\n\n\n.columnContact {\n  flex: 0.1;\n}\n\n\n.gapDiv {\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: calc(100vw * 0.17);\n}\n\n.columnEmail {\n  flex: 0.15;\n}\n\n.columnRecognitions {\n  flex: 0.15;\n  text-align: center;\n}\n\n.columnMonth {\n  flex: 0.20;\n  color: var(--_16c098-color);\n  text-align: center;\n}\n\n\n\n\n\n\n.icon {\n  width: 16px;\n  height: 16px;\n}\n\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 34px;\n  height: 20px;\n}\n\n.switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: var(--c-background);\n  border-radius: 34px;\n  cursor: pointer;\n  transition: 0.4s;\n}\n\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 14px;\n  width: 14px;\n  left: 3px;\n  bottom: 3px;\n  background-color: var(--white-background);\n  border-radius: 50%;\n  transition: 0.4s;\n}\n\ninput:checked+.slider {\n  background-color: var(--_16c098-background);\n}\n\ninput:checked+.slider:before {\n  transform: translateX(14px);\n}\n\n.pagination {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 0;\n  font-size: 14px;\n  color: var(--b5b7c0-color);\n}\n\n.paginationControls {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.pageNumber {\n  padding: 4px 8px;\n  cursor: pointer;\n  border-radius: 4px;\n  color: var(--_292d32-color);\n}\n\n.iconWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 55px;\n  height: 55px;\n  min-width: 55px;\n  min-height: 55px;\n  border-radius: 50%;\n  background: linear-gradient(to right, var(--d8ffea-background) 0%, var(--effff6-background) 37%, var(--effff6-background) 100%);\n}\n\n.pageNumber:hover {\n  background-color: var(--f8f9fa-background);\n}\n\n.chevron {\n  color: var(--b5b7c0-color);\n  cursor: pointer;\n}\n\n.tableTopContainer {\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n  gap: 20px;\n}\n\n.tableHeaderContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n\n.addClientButton {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  font-size: 14px;\n  font-weight: 400;\n  cursor: pointer;\n  user-select: none;\n  align-items: center;\n  justify-content: flex-start;\n  background: linear-gradient(90deg, var(--_11a380-background) 0%, var(--_0c6d56-background) 100%);\n  color: var(--white-color);\n  outline: none;\n  padding: 0px 10px;\n  height: 42px;\n  border: none;\n  border-radius: 7px;\n  -webkit-border-radius: 7px;\n  -moz-border-radius: 7px;\n  -ms-border-radius: 7px;\n  -o-border-radius: 7px;\n}\n\n.tableSpan {\n  color: var(--_16c098-color);\n  font-size: 14px;\n  font-weight: 400;\n}\n\n\n\n.dropdownContainer {\n  position: relative;\n  display: inline-block;\n}\n\n.filterSort {\n  font-size: 12px;\n  font-weight: 400;\n  color: var(--_7e-color);\n  height: 40px;\n  border: 1px solid var(--d8-border);\n  border-radius: 10px;\n  padding: 0px 12px;\n  width: 240px;\n  max-width: 240px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  cursor: pointer;\n}\n\n.filterSort b {\n  font-weight: 600;\n  color: var(--_3d3c42-color);\n  margin-left: 6px;\n}\n\n.chevronIcon {\n  margin-left: auto;\n  color: var(--_292d32-color);\n}\n\n.dropdownOptions {\n  position: absolute;\n  top: calc(100% - 2px);\n  left: 0;\n  width: 100%;\n  margin-top: 4px;\n  background: var(--white-background);\n  border-radius: 10px;\n  box-shadow: 0px 4px 8px var(--_0000001a-shadow);\n  z-index: 1000;\n  overflow: hidden;\n}\n\n.dropdownOption {\n  padding: 8px 12px;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--_9c9d9f-color);\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.dropdownOption:hover {\n  background-color: var(--f0f2f8-background);\n}\n\n\n\n\n.greenButton {\n  width: 100px;\n  background: linear-gradient(90deg, var(--_11a380-background) 0%, var(--_0c6d56-background) 100%);\n\n  color: var(--white-color);\n  font-size: 11px;\n  height: 30px;\n  font-weight: 400;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  user-select: none;\n  gap: 5px;\n}\n\n.homeContainer {\n  width: 100%;\n  /* background-color: var(--white-background); */\n  /* border-radius: 20px 0px 0px 0px; */\n  min-height: 100vh;\n  overflow-y: scroll;\n}\n\n.statisticsHeader {\n  display: flex;\n  width: 100%;\n  padding: 0px 10px;\n  box-sizing: border-box;\n  gap: 20px;\n\n  >div {\n    width: 100%;\n  }\n\n  .staticsContainer {\n    display: flex;\n    flex-wrap: wrap;\n  }\n\n  p {\n    margin: 0;\n  }\n\n  .statisticCard {\n    flex: 1;\n    padding: 20px;\n    box-sizing: border-box;\n  }\n\n  .title {\n    display: flex;\n    justify-content: space-between;\n\n    p {\n      font-size: 20px;\n      font-weight: bold;\n      text-transform: capitalize;\n    }\n\n    .icon {\n      cursor: pointer;\n      transform: rotate(90deg);\n      -webkit-transform: rotate(90deg);\n      -moz-transform: rotate(90deg);\n      -ms-transform: rotate(90deg);\n      -o-transform: rotate(90deg);\n    }\n  }\n\n  span {\n    color: var(--a6-color);\n    font-weight: bold;\n    text-transform: uppercase;\n  }\n\n  .statisticTotal {\n    font-size: 30px;\n    text-align: end;\n    font-weight: bold;\n  }\n}\n\n@media screen and (max-width: 1024px) {\n\n  .statisticsHeader,\n  .homeContent {\n    flex-direction: column;\n  }\n}\n\n.divider {\n  width: 100%;\n  height: 8px;\n  background-color: var(--f3-background);\n  border-radius: 99px;\n  -webkit-border-radius: 99px;\n  -moz-border-radius: 99px;\n  -ms-border-radius: 99px;\n  -o-border-radius: 99px;\n}\n\n.analitycsHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px;\n  padding: 10px;\n\n  .data {\n    display: flex;\n    align-items: center;\n    margin-left: 10px;\n    gap: 10px;\n\n    svg {\n      width: 30px;\n      height: 30px;\n    }\n  }\n}\n\n.analitycsHeaderRight {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  flex-wrap: wrap;\n\n  @media (width <=768px) {\n    padding: 0 10px;\n  }\n}\n\n.timerContainer {\n  display: flex;\n  align-items: center;\n  flex: 1;\n  gap: 10px;\n}\n\n.talkWithFacturaGPT {\n  display: flex;\n  height: 38px;\n  min-width: 225px;\n  padding: 0px 12px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  flex: 1;\n  border-radius: 8px;\n  background: var(--_10a37f-background);\n  box-shadow:\n    0px 0px 2px 0px var(--_00000008-shadow),\n    0px 0px 0px 0px var(--_00000000-shadow),\n    0px 0px 0px 0px var(--_00000000-shadow);\n  color: var(--white-color);\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 24px;\n  cursor: pointer;\n}\n\n.homeContent {\n  display: flex;\n  padding: 20px;\n  flex-wrap: wrap;\n  gap: 20px;\n}\n\n.salesSummaryContainer {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 50px;\n  box-sizing: border-box;\n}\n\n.salesSummary {\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n}\n\n.salesSummaryHeader {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n\n  p {\n    font-weight: bold;\n    font-size: 20px;\n    margin: 0;\n  }\n\n  span {\n    color: var(--a6-color);\n    font-weight: bold;\n    font-size: 20px;\n    text-transform: uppercase;\n  }\n}\n\n\n\n.salesSummaryOptions {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n\n  span {\n    text-transform: initial;\n    font-size: 16px;\n    color: var(--_00000035-color);\n  }\n}\n\n.monthsContainer {\n  display: flex;\n  gap: 10px;\n\n  p::before {\n    content: \"\";\n    height: var(--percent, 2px);\n    min-height: 2px;\n    width: 100%;\n    background-color: var(--_2b0e50-background);\n    display: block;\n    position: absolute;\n    top: 0px;\n  }\n\n  p {\n    margin: 0;\n    padding-top: 10px;\n    position: relative;\n    flex: 1;\n  }\n}\n\n.expenseAccounts {\n  flex: 1;\n}\n\n.expenseAccounts {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n\n  p {\n    margin: 0;\n  }\n\n  .spent {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    margin-bottom: 10px;\n\n    .row {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n\n      p {\n        color: var(--black-color);\n        font-weight: bold;\n      }\n    }\n\n    span {\n      color: var(--_22024b-color);\n      min-width: 150px;\n    }\n  }\n}\n\n.expenseAccountsOptions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin: 10px 0;\n\n  span {\n    text-transform: initial;\n    font-size: 16px;\n    color: var(--_00000035-color);\n    font-weight: bold;\n    cursor: pointer;\n  }\n\n  .selectedTypeExpense {\n    font-weight: bold;\n    font-size: 20px;\n    margin: 0;\n    color: var(--black-color);\n  }\n}\n\n.expenseAccountsHeader {\n  display: flex;\n  gap: 10px;\n\n  button {\n    flex: 1;\n    background-color: transparent;\n    border: none;\n    outline: none;\n    color: var(--_b4-color);\n    font-family: Inter;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n    cursor: pointer;\n    border: 1px solid transparent;\n    padding: 1px;\n    border-radius: 8px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n  }\n\n  .selectedTabBtn {\n    color: var(--_0d-color);\n    border: 1px solid var(--_0000001a-border);\n    box-shadow:\n      0px 0px 2px 0px var(--_00000008-shadow),\n      0px 0px 0px 0px var(--_00000000-shadow),\n      0px 0px 0px 0px var(--_00000000-shadow);\n  }\n}\n\n.buttonContainerTableTop {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n\n}\n\n.buttonContainerTableTop1 {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  label {\n     margin: 0px;\n  }\n  button {\n    background-color: transparent;\n    border: none;\n    outline: none;\n    cursor: pointer;\n    width: 30px;\n    height: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 5px;\n    background-color: var(--white-background);\n    border: 1px solid var(--_0000001a-border);\n  }\n}\n\n.filtersTableTop {\n  display: flex;\n  flex-direction: column;\n  align-items: end;\n  gap: 16px;\n  margin-bottom: 12px;\n  flex-wrap: wrap;\n}\n\n.searchIconsWrappers {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modalContent {\n  background: var(--white-background);\n  padding: 24px;\n  border-radius: 12px;\n  max-width: 500px;\n  width: 90%;\n  max-height: 80vh;\n  overflow-y: auto;\n}\n\n.modalContent h2 {\n  margin: 0 0 16px 0;\n  color: var(--black-color);\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.modalContent p {\n  margin: 8px 0;\n  color: var(--b5b7c0-color);\n  font-size: 14px;\n}\n\n.modalContent ul {\n  margin: 12px 0;\n  padding-left: 20px;\n}\n\n.modalContent li {\n  margin: 4px 0;\n  color: var(--b5b7c0-color);\n  font-size: 14px;\n}\n\n.modalButtons {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  margin-top: 24px;\n}\n\n.paymentMethodInfo{\n  display: flex;\n  align-items: center;\n  object-fit: contain;\n  gap: 5px;\n  img{\n    height: 10px;\n    width: 20px;\n  }\n  .cardInfo{\n    display: flex;\n    flex-direction: column;\n  }\n}\n\n.succeeded{\n  color: rgb(0, 159, 122);\n}\n.failed{\n  color: rgb(197, 34, 31);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_PsShl`,
	"statsContainer": `statsContainer_sX6Ge`,
	"statsContainerImport": `statsContainerImport_qyTOQ`,
	"statsContainerImportList": `statsContainerImportList_ByOHF`,
	"infoProfilesContainer": `infoProfilesContainer_mBCTh`,
	"initials": `initials_L8C0Q`,
	"profileImage": `profileImage_Yr8de`,
	"statCard": `statCard_YHtBc`,
	"statContent": `statContent_HgDd1`,
	"statTitle": `statTitle_szfQ5`,
	"statValue": `statValue_nehsA`,
	"statChange": `statChange_aY8nJ`,
	"positive": `positive_J0g2_`,
	"negative": `negative_y2BBw`,
	"avatars": `avatars_RccrB`,
	"tableSection": `tableSection_p2Dse`,
	"changeTabButton": `changeTabButton_veGf2`,
	"tableTitle": `tableTitle_sXPia`,
	"filters": `filters_yDDnY`,
	"filterSearch": `filterSearch_XpCR5`,
	"filterSort": `filterSort_zIqnm`,
	"tableHeader": `tableHeader_fvqLu`,
	"tableRow": `tableRow_SChJd`,
	"columnName": `columnName_C8lYx`,
	"columnContact": `columnContact_nFWHe`,
	"gapDiv": `gapDiv_cFGfI`,
	"columnEmail": `columnEmail_rDPI7`,
	"columnRecognitions": `columnRecognitions_Ji1XE`,
	"columnMonth": `columnMonth_Rnvew`,
	"icon": `icon_SbYxE`,
	"switch": `switch_FRiWE`,
	"slider": `slider_V2WrS`,
	"pagination": `pagination_MSnhR`,
	"paginationControls": `paginationControls_SLEwv`,
	"pageNumber": `pageNumber__Vzk9`,
	"iconWrapper": `iconWrapper_tgfER`,
	"chevron": `chevron_rNpyo`,
	"tableTopContainer": `tableTopContainer_k6PtO`,
	"tableHeaderContainer": `tableHeaderContainer_ZV2eV`,
	"addClientButton": `addClientButton_hakxl`,
	"tableSpan": `tableSpan_Qq0Fc`,
	"dropdownContainer": `dropdownContainer_n6vV5`,
	"chevronIcon": `chevronIcon_P_J98`,
	"dropdownOptions": `dropdownOptions_kX65y`,
	"dropdownOption": `dropdownOption_LB2Yk`,
	"greenButton": `greenButton_uhelQ`,
	"homeContainer": `homeContainer_bn3Hg`,
	"statisticsHeader": `statisticsHeader_RD3Ci`,
	"staticsContainer": `staticsContainer_MFDb5`,
	"statisticCard": `statisticCard_IBsfn`,
	"title": `title_EWm1x`,
	"statisticTotal": `statisticTotal_vh3Sr`,
	"homeContent": `homeContent_GUAgA`,
	"divider": `divider_nF46r`,
	"analitycsHeader": `analitycsHeader_P75bM`,
	"data": `data_FVSUh`,
	"analitycsHeaderRight": `analitycsHeaderRight_pntob`,
	"timerContainer": `timerContainer__JLBg`,
	"talkWithFacturaGPT": `talkWithFacturaGPT_no3cg`,
	"salesSummaryContainer": `salesSummaryContainer_DW9a_`,
	"salesSummary": `salesSummary_VkaAl`,
	"salesSummaryHeader": `salesSummaryHeader_AKY40`,
	"salesSummaryOptions": `salesSummaryOptions_ssmyT`,
	"monthsContainer": `monthsContainer_s6jdY`,
	"expenseAccounts": `expenseAccounts_EDuFf`,
	"spent": `spent_Kz9jE`,
	"row": `row__sQtm`,
	"expenseAccountsOptions": `expenseAccountsOptions_bsd00`,
	"selectedTypeExpense": `selectedTypeExpense_doWdz`,
	"expenseAccountsHeader": `expenseAccountsHeader_gB60I`,
	"selectedTabBtn": `selectedTabBtn_gHAJA`,
	"buttonContainerTableTop": `buttonContainerTableTop_yMlrM`,
	"buttonContainerTableTop1": `buttonContainerTableTop1_soK5f`,
	"filtersTableTop": `filtersTableTop_td1vG`,
	"searchIconsWrappers": `searchIconsWrappers_P_OdA`,
	"modalOverlay": `modalOverlay_LRD9I`,
	"modalContent": `modalContent_Id1Xr`,
	"modalButtons": `modalButtons_i3LJM`,
	"paymentMethodInfo": `paymentMethodInfo_lAOHv`,
	"cardInfo": `cardInfo_ktTLf`,
	"succeeded": `succeeded_qJwL3`,
	"failed": `failed_K3A16`
};
export default ___CSS_LOADER_EXPORT___;
